import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';
import { DataService, PaymentRecord, PaymentType } from '@core/services/data.service';
import { PartnersService } from '@core/services/partners.service';
import { ServicesService } from '@core/services/services.service';
import { Multilingual } from '@core/utilities/multilingual';
import { MessageBoxService } from '@routes/common/message-box.service';
import { map } from 'rxjs/operators';
import { UsersService } from '@core/services/users.service';

@Component({
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {

  @Input()
  public payment: PaymentRecord

  @Input()
  public reasons: { Stamp: number; Amount: number; Tag: string }[] = [];

  @Output()
  public deleted = new EventEmitter<PaymentRecord>();

  constructor(private users: UsersService, private partners: PartnersService, private services: ServicesService, private decimal: DecimalPipe, private modal: ModalService, private ds: DataService, private ms: MessageBoxService) { }

  ngOnInit(): void {
  }

  public get partner(): { ID: number; Name: string; Address: string } {

    let result: { ID: number, Name: string; Address: string };
    
    switch (this.payment.Type & (PaymentType.Partner | PaymentType.Service)) {
      case PaymentType.Partner: result = this.partners.get(this.payment.PartnerID); break;
      case PaymentType.Service: result = this.services.get(this.payment.PartnerID); break;
    }

    return result ? result : { ID: this.payment.PartnerID, Name: '', Address: '' };
  }

  public get type(): 'income' | 'expense' {
    return (this.payment.Type & PaymentType.Income) > 0 ? 'income' : 'expense';
  }

  public get subject(): 'service' | 'partner' {
    return (this.payment.Type & PaymentType.Partner) > 0 ? 'partner' : 'service';
  }

  public get title(): string {
    return Multilingual.getText('Phiếu ' + ((this.payment.Type & PaymentType.Income) == PaymentType.Income ? 'thu từ' : 'chi tới') + ' ' + ((this.payment.Type & PaymentType.Service) == PaymentType.Service ? 'dịch vụ' : 'đối tác')) + ' (P' + this.payment.ID + ')'; 
  }

  public get used(): number {
    return this.reasons.sum(i => i.Amount);
  }

  public get left(): number {
    return (this.type == 'expense' ? this.payment.ReceiveAmount : this.payment.SendAmount) - this.used;
  }

  public get deletable(): boolean {
    return this.users.current.Roles.contains("Owner");
  }

  public delete() {
    this.ms.confirms('discourage', "Bạn muốn xóa phiếu " + (this.type == 'income' ? 'thu' : 'chi') + " <b>" + this.decimal.transform(this.type == 'income' ? this.payment.ReceiveAmount : this.payment.SendAmount, '1.0-0', 'en-US') + ' ' + (this.type == 'income' ? this.payment.ReceiveSymbol : this.payment.SendSymbol) + "</b> của <b>" + this.partner.Name + "</b>?", () => this.ds.payments('delete', this.payment).pipe(map(result => {
      if (result && result.length == 1) {
        this.modal.of(this).hide();
        this.deleted.emit(this.payment);
        return true;
      }

      return false;
    })));    
  }

}
